import { uniqBy, uniqWith } from "lodash";
import { Activity, MyActivity as Submission } from "../fragments";

export const recentActivitiesList = ({
  submissionsByExpiration,
  submissionsByUpdate,
}: {
  submissionsByExpiration: [Submission] | [];
  submissionsByUpdate: [Submission] | [];
}) => {
  const expiringSoon = submissionsByExpiration.filter((s) => s.expiresSoon);
  const submissions = [...expiringSoon, ...submissionsByUpdate, ...submissionsByExpiration];

  return uniqBy(submissions, "id").slice(0, 3);
};

const activityListUniqueTag = (actA: Activity, actB: Activity) => {
  const hasTagIndex = actB.tags.flatMap((t) => actA.tags.map((v) => v.name === t.name));
  return !hasTagIndex.some((v) => v === false);
};

export const findActivitiesList = (activities: Activity[]) => {
  return uniqWith(activities, activityListUniqueTag).slice(0, 6);
};
